import { z } from 'zod';
import { stateSnapshotSchema } from './domain/game.js';
export const privateBulletinDraftSchema = z.object({
    teamId: z.string().min(1),
    markdown: z.string().min(1).max(10_000),
});
export const manualResolutionContentSchema = z.object({
    summary: z.string().min(1).max(10_000),
    nextState: stateSnapshotSchema,
    broadcast: z.object({
        headline: z.string().min(1).max(300),
        worldTime: z.string().max(200).optional(),
        publicMarkdown: z.string().min(1).max(30_000),
    }),
    privateBulletins: z.array(privateBulletinDraftSchema).max(20),
});
export const externalAssistanceSchema = z.object({
    prompt: z.string().max(70000),
    response: z.string().max(70000),
});
export const manualResolutionDraftSchema = z.object({
    id: z.string(),
    gameId: z.string(),
    roundNo: z.number().int().positive(),
    version: z.number().int().positive(),
    content: manualResolutionContentSchema,
    externalAssistance: externalAssistanceSchema.optional(),
    createdAt: z.string().datetime(),
});
export const manualResolutionCommandSchema = z.object({
    expectedRoundVersion: z.number().int().nonnegative(),
    content: manualResolutionContentSchema,
    externalAssistance: externalAssistanceSchema.optional(),
});
export const approvalCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
    expectedRoundVersion: z.number().int().nonnegative(),
    draftId: z.string().min(1),
});
export const versionedCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
    expectedRoundVersion: z.number().int().nonnegative(),
});
export const advanceCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
    destination: z.enum(['NEXT_ROUND', 'FINAL_DEBRIEF']),
});
export const setupAdvanceCommandSchema = z.object({
    expectedGameVersion: z.number().int().nonnegative(),
    destination: z.enum(['REVEAL', 'ROUND_ACTIVE']),
});
export const setupTeamStatusSchema = z.object({
    teamId: z.string(),
    displayName: z.string(),
    organizationName: z.string().optional(),
    organizationConfirmed: z.boolean(),
    assignmentStatus: z.enum(['NOT_STARTED', 'PREPARED', 'REVEALED']),
});
export const roundReviewSchema = z.object({
    gameId: z.string(),
    roundNo: z.number().int().positive(),
    status: z.string(),
    version: z.number().int().nonnegative(),
    submissions: z.array(z.object({
        teamId: z.string(),
        officialVersion: z.number().int().positive(),
        submittedAt: z.string().datetime(),
        brief: z.unknown(),
    })),
});
export const moderatorGameViewSchema = z.object({
    game: z.object({
        gameId: z.string(),
        phase: z.string(),
        version: z.number().int().nonnegative(),
        activeRoundNo: z.number().int().positive().nullable(),
        currentStateVersion: z.number().int().nonnegative(),
    }),
    round: z
        .object({
        roundNo: z.number().int().positive(),
        status: z.string(),
        version: z.number().int().nonnegative(),
    })
        .optional(),
    currentState: stateSnapshotSchema,
    setupTeams: z.array(setupTeamStatusSchema),
});
export const worldBroadcastSchema = z.object({
    id: z.string(),
    gameId: z.string(),
    roundNo: z.number().int().positive(),
    status: z.enum(['PREPARED', 'PUBLISHED']),
    headline: z.string(),
    worldTime: z.string().optional(),
    publicMarkdown: z.string(),
    publishedAt: z.string().datetime().optional(),
});
export const privateBulletinSchema = z.object({
    id: z.string(),
    gameId: z.string(),
    roundNo: z.number().int().positive(),
    teamId: z.string(),
    status: z.enum(['PREPARED', 'PUBLISHED']),
    markdown: z.string(),
    publishedAt: z.string().datetime().optional(),
});
export const approvalResultSchema = z.object({
    resolutionId: z.string(),
    stateVersion: z.number().int().nonnegative(),
    broadcast: worldBroadcastSchema,
    findings: z.array(z.object({ severity: z.enum(['HARD', 'ADVISORY']), code: z.string(), message: z.string() })),
});
//# sourceMappingURL=manual-round.js.map